// Module
var code = "<div class=\"fields\"></div> <div class=\"addField\"> <a class=\"btn-flat waves-effect waves-blue\">ADD FIELD</a> </div> ";
// Exports
export default code;